import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconFileTextProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconFileText: React.FC<IconFileTextProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Content',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 9H8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 13H8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 17H8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconFileText;
